import React from 'react';
import { Modal } from "antd";
import { COLORS } from './utils/Constants';
import StepOne from './identity/StepOne';
import StepTwo from './identity/StepTwo';
import StepThree from './identity/StepThree';
import StepFour from './identity/StepFour';
import StepFive from './identity/StepFive';
import StepSix from './identity/StepSix';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

let stepNumber = 0;
const whiteColor = '#a6b2d1', yellowColor = '#BD9806', blueColor = '#5A6A7A', redColor = '#FF8888', greenColor = '#8DCB4F';

export default class IdentityModal extends React.Component {

  constructor(props) {
    super(props);
    console.log('id status value='+props.statusValue);
    stepNumber = this.identityStatus(props.statusValue);
    this.state = { visible: true, stepNumber: stepNumber };
  }  

  setModalVisible = () => {
    this.setState({ visible: false }, () => {
      this.props.closeIdentityPopup();
    });
  }

  identityStatus = (value) => {
    console.log('identity Status value='+value);
    if(value=="Passed") {
      // StepFour
      return 4;
    } else if(value=="Pending") {
      // StepThree
      return 3;
    } else if(value=="Rejected") {
      // StepFive
      return 5;
    } else {
      // StepOne
      return 1;
    }
  }

  startVerification = () => {
    stepNumber = 2;
    this.setState({ stepNumber: 2 });
  }

  documentUploaded = () => {
    stepNumber = 3;
    this.setState({ stepNumber: 3 });
  }

  deleteID = () => {
    stepNumber = 6;
    this.setState({ stepNumber: 6 });
  }

  deleteIDSuccess = () => {
    stepNumber = 1;
    this.setState({ stepNumber: 1 });
  }

  render() {
    let isMobile = window.innerWidth<768;
    let modalHeight = 540;
    let stepUI = null;
    switch(stepNumber) {
      case 2:
        stepUI = <StepTwo blueColor={blueColor} yellowColor={yellowColor} redColor={redColor} 
        sessionValue={this.props.sessionValue} documentUploaded={this.documentUploaded} />;
        modalHeight = 860;
        break;
      case 3:
        stepUI = <StepThree yellowColor={yellowColor} />;
        break;
      case 4:
        stepUI = <StepFour whiteColor={whiteColor} yellowColor={yellowColor} identityVerificationTime={this.props.identityVerificationTime}
        redColor={redColor} greenColor={greenColor} sessionValue={this.props.sessionValue} deleteID={this.deleteID} />;
        break;
      case 5:
        stepUI = <StepFive whiteColor={whiteColor} yellowColor={yellowColor} redColor={redColor} 
        greenColor={greenColor} startVerification={()=>{ this.startVerification() }} />;
        break;
      case 6:
        stepUI = <StepSix whiteColor={whiteColor} yellowColor={yellowColor} redColor={redColor}
        deleteIDSuccess={this.deleteIDSuccess} sessionValue={this.props.sessionValue} />;
        break;
      default:
        stepUI = <StepOne whiteColor={whiteColor} yellowColor={yellowColor} startVerification={()=>{ this.startVerification() }} />;
        break;
    }

    return (
      <Modal
        width={384} 
        maskClosable={false}
        visible={this.state.visible}
        centered={isMobile ? true : false}
        closeIcon={<FontAwesomeIcon icon={faTimes} style={{ color: yellowColor, marginTop: 48, fontSize: 20 }} />}
        bodyStyle={{ top: isMobile ? '10%' : '0%', height: modalHeight, padding: 0, backgroundColor: COLORS.white }}
        onOk={() => this.setModalVisible(false)}
        onCancel={() => this.setModalVisible(false)}
        footer={null}
      >
        <div style={{ display: 'flex', width: '100%', height: '100%', flexDirection: 'column', padding: 4, backgroundColor: yellowColor }}>
          <div style={{ display: 'flex', justifyContent:'center', height: '100%', backgroundColor: COLORS.blue2a3a4a }}>
            {stepUI}
          </div>
        </div>
      </Modal>
  );
  }
}
